var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#E8F2FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 43.125H82.5",
    stroke: "#5582A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.875 37.5V48.75",
    stroke: "#5582A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2631 80.6228C39.5683 76.6327 42.8829 73.3195 46.874 71.016C50.8651 68.7126 55.3921 67.5 60.0003 67.5C64.6084 67.5 69.1354 68.7128 73.1264 71.0163C77.1175 73.3199 80.4321 76.6331 82.7372 80.6233",
    stroke: "#5582A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0746 57.6991C73.0719 60.4063 71.309 62.7664 68.9975 64.496C66.686 66.2255 63.9243 67.2509 61.0442 67.449C58.164 67.647 55.288 67.0093 52.7615 65.6124C50.2351 64.2155 48.1656 62.1189 46.8019 59.5744C45.4381 57.0299 44.838 54.1458 45.0736 51.2685C45.3092 48.3912 46.3706 45.6431 48.1302 43.3544C49.8897 41.0657 52.2727 39.3337 54.9928 38.3665C57.7128 37.3993 60.6543 37.2379 63.4638 37.9019",
    stroke: "#5582A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar-default.3d007a345d0c40e1be649c8b70456d7a.svg";
export { ForwardRef as ReactComponent };